export class ServiceCode {
    public id: number = 0
    public code_type: string = ""
    public code_no: string = ""
    public name: string = ""
    public unit: string = ""
}